import axios from 'axios';

// Use relative URLs for API calls so they work on ANY domain (preview, custom, local).
// The Kubernetes ingress routes /api/* to the backend regardless of the host domain.
// This eliminates cross-origin issues when deployed to custom domains.
const api = axios.create({});

// Public API alias - same config, kept for backward compatibility
export const publicApi = axios.create({});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('session_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth data on 401
      localStorage.removeItem('session_token');
      localStorage.removeItem('user_data');
      // Only redirect to login for protected routes, not public pages
      const publicPaths = ['/blog', '/login', '/'];
      const isPublicPath = publicPaths.some(path => window.location.pathname.startsWith(path));
      if (!isPublicPath && !window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
